import React from 'react';
import './EditAddress.css';

import { PageTitle } from '../../../../components';

const EditAddress = () => {

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    // Reset the form fields
    event.target.reset();
  };

  return (
    <>
      {/* Page Title - Update to reflect address editing */}
      <PageTitle title={'edit address'} page={'edit address'} />

      <section className='edit-address'>
        {/* Edit Address Form */}
        <form className='account-form' onSubmit={handleSubmit}>
          <h3>edit address</h3>
          
          {/* First row - First Name and Last Name */}
          <div className='input-box'>
            <input type="text" name="first-name" placeholder="first name" id="first-name" className='box' />
            <input type="text" name="last-name" placeholder="last name" id="last-name" className='box' />
          </div>

          {/* Second row - Company and Country */}
          <div className='input-box'>
            <input type="text" name="company" placeholder="company (optional)" id="company" className='box' />
            <input type="text" name="country" placeholder="country" id="country" className='box' />
          </div>

          {/* Third row - Address and City */}
          <div className='input-box'>
            <input type="text" name="address" placeholder="address" id="address" className='box' />
            <input type="text" name="city" placeholder="city" id="city" className='box' />
          </div>

          {/* Fourth row - Province and ZIP */}
          <div className='input-box'>
            <input type="text" name="province" placeholder="province" id="province" className='box' />
            <input type="text" name="zip" placeholder="ZIP" id="zip" className='box' />
          </div>

          {/* Submit Button */}
          <button type="submit" className='btn' name="edit-address" id="edit-address">edit address</button>
        </form>
      </section> 
    </> 
  );
}

export default EditAddress;